import Loadable from "react-loadable"
import { Loading } from "@/components/Loading"

export const RedirectSnaphire = Loadable({
  loader: () => import("./RedirectSnaphire"),
  loading: Loading
})
